import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LogoutIcon from '@mui/icons-material/ExitToApp';
import { Badge, Button, Link, Stack, Tooltip } from '@mui/material';
import moment from 'moment';

import { Span } from '@notablehealth/design-system';
import {
  AuthSessionStatus,
  isDefined,
  useAuthExpirationContext,
  useLoggedInAuthContext,
} from 'common';

import { setLoginEmail } from '../../../utils/login';
import { useSideNavigationAnimation } from '../Animation';
import { SIDEBAR_NAVIGATION_SX_MARGIN_X } from '../constants';
import { SideNavigationState, useSideNavigationModeContext } from '../context';

export function SidebarNavigationBottomSection() {
  const { sideNavigationOpacityAnimation } = useSideNavigationAnimation();
  const { sideNavigationState } = useSideNavigationModeContext();

  const { logout } = useLoggedInAuthContext();
  const { sessionExpirationDate, sessionStatus } = useAuthExpirationContext();

  return (
    <Stack
      marginX={SIDEBAR_NAVIGATION_SX_MARGIN_X}
      gap={0.5}
      alignItems="flex-start"
      justifyContent="center"
    >
      <Button
        component={Link}
        variant="text"
        href="https://docs.notablehealth.com"
        target="_blank"
        rel="noopener noreferrer"
        underline="none"
        startIcon={<DescriptionOutlinedIcon />}
        color="inherit"
        fullWidth
        sx={{
          justifyContent: 'flex-start',
        }}
        tabIndex={sideNavigationState === SideNavigationState.Collapsed ? -1 : 0}
      >
        <Span sx={{ ...sideNavigationOpacityAnimation }}>Documentation</Span>
      </Button>
      <Tooltip
        placement="right"
        title={
          sessionStatus === AuthSessionStatus.Expired
            ? 'Session has expired'
            : isDefined(sessionExpirationDate)
              ? `Session expires ${moment(sessionExpirationDate).fromNow()}`
              : undefined
        }
      >
        <Button
          variant="text"
          color="inherit"
          startIcon={<LogoutIcon />}
          onClick={async () => {
            setLoginEmail(undefined);
            await logout();
          }}
          fullWidth
          sx={{
            justifyContent: 'flex-start',
          }}
          aria-label="Sign Out"
          tabIndex={sideNavigationState === SideNavigationState.Collapsed ? -1 : 0}
        >
          <Badge
            color="error"
            variant="dot"
            invisible={sessionStatus === AuthSessionStatus.Active}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              paddingRight: 1,
            }}
          >
            <Span sx={{ ...sideNavigationOpacityAnimation }}>Sign Out</Span>
          </Badge>
        </Button>
      </Tooltip>
    </Stack>
  );
}
